import { render, staticRenderFns } from "./LinkRegister.vue?vue&type=template&id=2f2c0f24&scoped=true&"
import script from "./LinkRegister.vue?vue&type=script&lang=js&"
export * from "./LinkRegister.vue?vue&type=script&lang=js&"
import style0 from "./LinkRegister.vue?vue&type=style&index=0&id=2f2c0f24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2c0f24",
  null
  
)

export default component.exports